import { createContext, useContext } from "react";

export const StoreSectionsContext = createContext({
  storeSections: [],
  updateStoreSections: () => {},
  fetchStoreSections: () => {},
  reloadStoreSections: () => {},
  StoreSectionDeletedHandler: () => {},
  HideStoreSectionsSkeleton: true,
  isUpdatedStoreSections: false,
  storeSectionsError: null,
  setHideStoreSectionsSkeleton: () => {},
  removeStoreSections: () => {}
});

export const useStoreSectionsContext = () => useContext(StoreSectionsContext);
